export default "__VITE_ASSET__Cp$89sBT__"